var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimpleCookingPanGrayOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 0.5H13.625V10C13.625 10.8284 12.9534 11.5 12.125 11.5H4.875C4.04657 11.5 3.375 10.8284 3.375 10V0.5Z",
    stroke: "#9296AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.899999 0.7C0.751943 0.7 0.622674 0.61956 0.553513 0.5H16.4465C16.3773 0.61956 16.2481 0.7 16.1 0.7H0.899999Z",
    stroke: "#9296AC",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleCookingPanGrayOutline);
export default __webpack_public_path__ + "static/media/simpleCookingPanGrayOutline.017702f860958be7ee461b69d6ff0250.svg";
export { ForwardRef as ReactComponent };